export default "__VITE_ASSET__DJx292OZ__"